import { User, ShareModel } from '../../../../core/models';

/**
 * This is Comp Share Model Class
 */
export default class CompShareModel extends ShareModel {
	getLeagueMessage() {
		const
			league_name  = this.get( 'league_name' ),
			user_name    = User.get( 'lastname' ) +' '+User.get( 'firstname' );

		return `${user_name} joined the ${league_name}` +
			` league of the official NRL Tipping competition. Sign-up now to join ${user_name}`+
			` and amp up the excitement for season 2023 `
	}

	getTeamMessage() {
		return `Create a league, invite your mates ` +
			`and battle it out for prizes and ultimate ` +
			`bragging rights! Click on the link to register for NRL Tipping`;
	}

	getShareFragment() {
		const
			team_share = this.get( 'team_share' ),
			league_fragment = 'share/tipping_league_invite',
			team_fragment = 'share/tipping';

		return ( team_share ) ? team_fragment : league_fragment;
	}
}